import { i as inject } from "../services/current-app-1538613c.mjs";
import { V as VaAppCachePluginKey } from "../services/cache/plugin/index-3da9421a.mjs";
const useCache = () => inject(VaAppCachePluginKey, {
  colorContrast: {}
});
export {
  useCache as u
};
//# sourceMappingURL=useCache-24ddee00.mjs.map
